import { newsList as localfull_news } from "constants/full_news";
// import { newsList } from "constants/full_news";

import { Col, Row, Stack } from "react-bootstrap";
import "./news.css";
import { useEffect, useState } from "react";
import alrajhi_logo from "assets/images/alrajhi_logo.svg";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import moment from "moment";
import axios from "axios";
import { isArray } from "lodash";
function ListNews() {
  const [tags, setTags] = useState([]);
  const [newsList, setNewsList] = useState(localfull_news);
  const [activeTag, setActiveTag] = useState("");

  const fetchNewsAndAnnouncementsCMS = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/news-and-announcements?sort=createdAt:desc&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    const fetchAdditionalData = async () => {
      try {
        const response = await fetch(
          "https://www.alrajhibank.com.my/assets/json/news.json"
        );
        const fetchedData = await response.json();
        const fetchDataCMS = await fetchNewsAndAnnouncementsCMS();

        const formattedCMSData =
          isArray(fetchDataCMS) &&
          fetchDataCMS.map((data) => ({
            // id: data.id,
            type: data.type || "News",
            title: data.title,
            date: moment(data.date).format("DD MMM YYYY"),
            tag: data.yearTag,
            slug: data.slug,
            description: data.contentTemplate,
            image: data.image,
            isFromCMS: true,
          }));

        const mergedData = [
          ...formattedCMSData,
          ...fetchedData.newsList,
          ...localfull_news,
        ];

        const uniqueTags = [...new Set(mergedData.map((item) => item.tag))];
        setTags(uniqueTags);
        setActiveTag(uniqueTags[0]);

        setNewsList(mergedData);
      } catch (error) {
        console.error("Error fetching news data:", error);
      }
    };

    fetchAdditionalData();
  }, []);
  return (
    <>
      <div className="container page">
        <h1 className="page-title">Latest News and Announcements</h1>
        {/* todo: button active color */}
        <Stack direction="horizontal" gap={3}>
          {tags.map((item, index) => {
            return (
              <div
                className={activeTag === item ? "btn-tag active" : "btn-tag"}
                onClick={() => setActiveTag(item)}
              >
                {item}
              </div>
            );
          })}
        </Stack>

        <div className="news-section">
          <Row>
            {newsList
              .filter((x) => x.tag === activeTag)
              .map((item, index) => (
                <Col md={4}>
                  <div className="news-card d-flex flex-column justify-content-between">
                    <div>
                      <div>
                        <img
                          alt="news_image_1"
                          src={item.image || alrajhi_logo}
                          style={{
                            objectFit: item.image ? `cover` : `scale-down`,
                          }}
                        />
                      </div>
                      <div className="d-flex flex-column justify-content-between content" style={{ height: "180px", overflow: "hidden", textOverflow: "ellipsis" }}>
                        <h1>
                          {item.title.length < 60
                            ? item.title
                            : item.title.substring(0, 60) + "..."}
                        </h1>
                        {!item.isFromCMS && (
                          <p>
                            {item.description.length < 60
                              ? parse(item.description)
                              : parse(item.description.substring(0, 60)) +
                                "..."}
                          </p>
                        )}
                        {item.isFromCMS && (
                          <p>
                            {item.description.length < 120
                              ? parse(item.description)
                              : parse(item.description.substring(0, 120) + "...")}
                          </p>
                        )}
                      </div>
                    </div>

                    <div>
                      <div>
                        {/* <p>
                          {item.description.length < 60
                            ? parse(item.description)
                            : parse(item.description.substring(0, 60)) + "..."}
                        </p> */}
                        <div className="d-flex justify-content-between align-items-baseline content">
                          <Link to={`/news/${item.slug}`}>Read More</Link>
                          <p>{item.date}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
          </Row>
        </div>

        {/* todo: update style */}
        {/* <div className="d-flex justify-content-center">
          <Pagination className="news-pagination d-flex align-self-center">
            <Pagination.Prev linkClassName="prev" />
            <Pagination.Item linkClassName="item">{1}</Pagination.Item>
            <Pagination.Item linkClassName="item active">{2}</Pagination.Item>
            <Pagination.Ellipsis linkClassName="item" />
            <Pagination.Item linkClassName="item">{9}</Pagination.Item>
            <Pagination.Item linkClassName="item">{10}</Pagination.Item>

            <Pagination.Next />
          </Pagination>
        </div> */}
      </div>
    </>
  );
}

export default ListNews;
